import React from 'react';
import { IoMdHome } from 'react-icons/io';
import { Link } from 'react-router-dom';

function Breadcrumb() {

    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb pl-0">
                <li className="breadcrumb-item"><Link to="/Accounts-Dashboard"><IoMdHome className='home' /> Home</Link></li>
                <li className="breadcrumb-item"><Link to="/Accounts-Vendors-PaymentStatement-List"> Vendors Payment Statement</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Vendor&apos;s Payment Statement Details</li>
            </ol>
        </nav>
    );
};

export default Breadcrumb;